window.addEventListener( "DOMContentLoaded", function()
{
    var bannerWrappers = document.querySelectorAll( ".bridgman-banner-parent" );
    bannerWrappers.forEach( function( banner )
    {
        if( banner.classList.contains( "slick-initialized" ) == false )
        {
            var sectionID = banner.getAttribute( "data-section-id" );
            var selector  = ".bridgman-banner-parent-" + sectionID;
            var speed     = banner.getAttribute( "data-swiper-speed" );
    
            var params = new URLSearchParams(window.location.search);
            if( params.size > 0 )
            {
                var swiperInitialized = false;
                for( var key of params.keys() )
                {
                    if( key == "campaign" )
                    {
                        var value = params.get( key );
                        if( value )
                        {
                            var slides = banner.querySelectorAll( ".bridgman-banner-container" );
                            for( var i = 0; i < slides.length; i++ )
                            {
                                var slide = slides[ i ];
                                var bannerCampaign = slide.getAttribute( "data-campaign" );
                                if( bannerCampaign && bannerCampaign == value )
                                {
                                    $( selector ).slick({
                                        autoplay: true, 
                                        infinite: true,
                                        autoplaySpeed: speed,
                                        slidesToShow: 1,
                                        slidesToScroll: 1,
                                        arrows: true,
                                        adaptiveHeight: true,
                                        initialSlide: i
                                    });
                                    swiperInitialized = true;
                                    break;
                                }
                            }
                        }
                    }
                }
                if( swiperInitialized == false )
                {
                    $( selector ).slick({
                        autoplay: true, 
                        infinite: true,
                        autoplaySpeed: speed,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: true,
                        adaptiveHeight: true
                    });
                }
            }
            else
            {
                $( selector ).slick({
                    autoplay: true, 
                    infinite: true,
                    autoplaySpeed: speed,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    adaptiveHeight: true
                });
            }
            $( selector + ' .bridgman-banner-container.hidden').removeClass('hidden');
            $( selector ).removeClass('visibility-hidden');
        }
    });
} );